import { buildApiUrl } from '../../config/api';
import authService from '../../modules/auth/services/authService';

/**
 * Envía feedback del usuario al backend
 * @param {string} description - Descripción del feedback
 * @returns {Promise<object>} Respuesta del servidor
 */
export const sendFeedback = async (description) => {
  const response = await authService.authenticatedRequest(
    buildApiUrl('/api/user/feedback/send'),
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ description }),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Error al enviar el feedback');
  }

  return response.json();
};

